<template>
  <div>
  <v-card class="pt-2 pb-4 px-4">
    <v-layout row wrap>
      <v-flex xs6>
        <SelectItems v-model="statuses" :items="statusesItems" itemText="text" itemValue="value" prepend-icon="fa-list"
                     label="Estados" :loading="loadingStatuses" :error-messages="statusesErrors"></SelectItems>
      </v-flex>
      <v-flex xs6 pl-2>
        <SelectItems v-model="clubs" :items="clubsItems" itemText="nombre" itemValue="pk" prepend-icon="fa-users"
                     label="Clubes" :loading="loadingClubs" :error-messages="clubsErrors"></SelectItems>
      </v-flex>
      <v-flex xs6>
        <DatePickerForm v-model="fromDate" label="Desde" :error-messages="fromDateErrors"></DatePickerForm>
      </v-flex>
      <v-flex xs5 px-2>
        <DatePickerForm v-model="toDate" label="Hasta" :error-messages="toDateErrors"></DatePickerForm>
      </v-flex>
      <v-flex xs1 class="align-center">
        <v-card-actions>
          <v-tooltip bottom>
            <v-btn slot="activator" icon @click="search" flat>
              <v-icon color="primary">search</v-icon>
            </v-btn>
            <span>Buscar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn slot="activator" icon @click="downloadExcelAfterValidForm" flat>
              <v-icon color="primary">far fa-file-excel</v-icon>
            </v-btn>
            <span>Descargar XLS</span>
          </v-tooltip>
        </v-card-actions>
      </v-flex>
    </v-layout>
    <v-divider class="mt-4 mb-4"></v-divider>
    <v-layout>
      <v-flex>
        <table>
          <tr>
            <th>Detalle</th>
            <th>Valores</th>
          </tr>
          <tr>
            <td>Desde</td>
            <td>{{ formatDate(fromDate) }}</td>
          </tr>
          <tr>
            <td>Hasta</td>
            <td>{{ formatDate(toDate) }}</td>
          </tr>
          <tr>
            <td>Presentaciones Creadas</td>
            <td>{{ responseValues.creadas }}</td>
          </tr>
          <tr>
            <td>En espera</td>
            <td>{{ responseValues.enEspera }}</td>
          </tr>
          <tr>
            <td>En carga</td>
            <td>{{ responseValues.enCarga }}</td>
          </tr>
          <tr>
            <td>Presentada</td>
            <td>{{ responseValues.presentada }}</td>
          </tr>
          <tr>
            <td>Vencida</td>
            <td>{{ responseValues.vencida }}</td>
          </tr>
          <tr>
            <td>Rechazada</td>
            <td>{{ responseValues.rechazada }}</td>
          </tr>
          <tr>
            <td>Aprobada</td>
            <td>{{ responseValues.aprobada }}</td>
          </tr>
          <tr>
            <td>A subsanar</td>
            <td>{{ responseValues.aSubsanar }}</td>
          </tr>
          <tr>
            <td>Subsanada</td>
            <td>{{ responseValues.subsanada }}</td>
          </tr>
          <tr>
            <td>Expediente Abierto</td>
            <td>{{ responseValues.expedienteAbierto }}</td>
          </tr>
          <tr>
            <td>Aprobada por Comité</td>
            <td>{{ responseValues.aprobadaPorComite }}</td>
          </tr>
          <tr>
            <td>Subsanada por Comité</td>
            <td>{{ responseValues.subsanadaPorComite }}</td>
          </tr>
        </table>
      </v-flex>
    </v-layout>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'
import { required } from 'vuelidate/lib/validators'
import DatePickerForm from '../../../common/ui/DatePickerForm'
import SelectItems from '../../../common/ui/SelectItems'

export default {
  mixins: [validationMixin, downloadFileMixin],

  components: {
    DatePickerForm,
    SelectItems
  },

  validations () {
    return {
      fromDate: { required },
      toDate: { required },
      statuses: { required },
      clubs: { required }
    }
  },

  data () {
    return {
      fromDate: null,
      toDate: null,
      statuses: [],
      statusesItems: [],
      clubs: [],
      clubsItems: [],
      loadingStatuses: true,
      loadingClubs: true,
      responseValues: {}
    }
  },

  computed: {
    fromDateErrors () {
      return this.getRequiredErrors('fromDate')
    },
    toDateErrors () {
      return this.getRequiredErrors('toDate')
    },
    statusesErrors () {
      return this.getRequiredErrors('statuses')
    },
    clubsErrors () {
      return this.getRequiredErrors('clubs')
    }
  },

  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    getRequiredErrors (property) {
      const errors = []
      if (!this.$v[property].$dirty) return errors
      !this.$v[property].required && errors.push('Este campo es requerido.')
      return errors
    },
    fetchClubs () {
      this.axios
        .get('clubes')
        .then(response => {
          this.clubsItems = response.data
          this.loadingClubs = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchStatuses () {
      this.axios
        .get('filters/presentations')
        .then(response => {
          this.statusesItems = response.data.filters.filter(filter => filter.value === 'status')[0].items
          this.loadingStatuses = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchData () {
      this.axios
        .get('presentations/details?' + this.getFilteringPath())
        .then(response => { this.responseValues = response.data })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    getFilteringPath () {
      let filterPath = `from=${this.fromDate}&to=${this.toDate}`
      for (let status of this.statuses) {
        filterPath += `&status[]=${status}`
      }
      for (let club of this.clubs) {
        filterPath += `&club[]=${club}`
      }
      return filterPath
    },
    getExcelPath () {
      return 'presentations/xls' + '?' + this.getFilteringPath()
    },
    getFilenamePrefix () {
      return 'presentaciones'
    },
    downloadExcelAfterValidForm () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.downloadExcel()
      }
    },
    search () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.fetchData()
      }
    }
  },

  created () {
    this.fetchClubs()
    this.fetchStatuses()
  }
}
</script>

<style scoped>
  table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }

  td, th {
    border: 1px solid #cbcbcb;
    text-align: left;
    padding: 8px;
  }

  tr:nth-child(even) {
    background-color: #ebebeb;
  }
</style>
